// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preferred-image[data-v-a3b7e7f0]{border:2px solid #79b928}", ""]);
// Exports
module.exports = exports;
